import { render, staticRenderFns } from "./vimeoGallery.vue?vue&type=template&id=2d8f842a"
import script from "./vimeoGallery.vue?vue&type=script&lang=js"
export * from "./vimeoGallery.vue?vue&type=script&lang=js"
import style0 from "./vimeoGallery.vue?vue&type=style&index=0&id=2d8f842a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports